// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__auyvw","subsection":"PrivacyPolicy_subsection__HFaon"};